/** Pure helpers for gate handover → next-gate inherited-input propagation. */

export function shouldPropagateHandover(outcome) {
  return outcome === 'pass' || outcome === 'conditional_pass';
}

/** Next lifecycle gate on the same project by order_index. */
export function findNextLifecycleGate(gates, passedGate) {
  if (!passedGate?.project_id) return null;
  const ordered = (gates || [])
    .filter((g) => g.project_id === passedGate.project_id && g.gate_type === 'lifecycle')
    .sort((a, b) => (a.order_index ?? 0) - (b.order_index ?? 0));
  const idx = ordered.findIndex((g) => g.id === passedGate.id);
  if (idx < 0 || idx >= ordered.length - 1) return null;
  return ordered[idx + 1];
}

/** Build inherited_input rows from handover_output items (skip duplicate titles on target gate). */
export function buildHandoverPropagationRows(handoverItems, nextGateId, existingOnNextGate) {
  if (!nextGateId) return [];
  const existing = new Set((existingOnNextGate || []).map((d) => (d.title || '').trim().toLowerCase()));
  return (handoverItems || [])
    .filter((d) => d.role === 'handover_output')
    .filter((d) => d.title && !existing.has(d.title.trim().toLowerCase()))
    .map((d, i) => ({
      gate_id: nextGateId,
      title: d.title.trim(),
      description: d.description || null,
      role: 'inherited_input',
      deliverable_id: d.deliverable_id || null,
      order_index: d.order_index ?? i + 1,
    }));
}
